<template>
  <section class="auth-page">
    <div class="auth-shell gt-card">
      <aside class="auth-brand">
        <div class="brand-badge">GT</div>
        <h1>Crea tu espacio de trabajo</h1>
        <p>Registra tu usuario, empresa y primera sucursal. Si vienes por vendedor o invitacion, el token viaja en la URL.</p>
      </aside>

      <main class="auth-form">
        <span class="gt-pill">Registro autoservicio</span>
        <h2>Crear cuenta</h2>
        <p class="gt-muted">Despues del registro podras completar la configuracion inicial.</p>

        <form @submit.prevent="handleRegister">
          <div class="two-cols">
            <div>
              <label class="gt-label">Nombre</label>
              <input v-model.trim="form.name" class="gt-input" type="text" placeholder="Nombre completo" />
            </div>
            <div>
              <label class="gt-label">Correo</label>
              <input v-model.trim="form.email" class="gt-input" type="email" placeholder="correo@empresa.com" />
            </div>
          </div>

          <div class="two-cols">
            <div>
              <label class="gt-label">Contrasena</label>
              <input v-model="form.password" class="gt-input" type="password" placeholder="Minimo 8 caracteres" />
            </div>
            <div>
              <label class="gt-label">Confirmar</label>
              <input v-model="confirmPassword" class="gt-input" type="password" />
            </div>
          </div>

          <div class="two-cols">
            <div>
              <label class="gt-label">Empresa</label>
              <input v-model.trim="form.company_name" class="gt-input" type="text" placeholder="Nombre comercial" :disabled="!!form.invite_token" />
            </div>
            <div>
              <label class="gt-label">Sucursal inicial</label>
              <input v-model.trim="form.branch_name" class="gt-input" type="text" placeholder="Matriz" :disabled="!!form.invite_token" />
            </div>
          </div>

          <div class="two-cols">
            <div>
              <label class="gt-label">Token de vendedor</label>
              <input v-model.trim="form.seller_token" class="gt-input" type="text" placeholder="Opcional" />
            </div>
            <div>
              <label class="gt-label">Invitacion</label>
              <input v-model.trim="form.invite_token" class="gt-input" type="text" placeholder="Opcional" />
            </div>
          </div>

          <button class="gt-button primary" type="submit" :disabled="loading">{{ loading ? 'Creando...' : 'Crear cuenta' }}</button>
        </form>

        <p class="footer-link">Ya tienes cuenta? <router-link to="/login">Inicia sesion</router-link></p>
        <p v-if="error" class="error">{{ error }}</p>
      </main>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'RegisterView',
  props: { sellerToken: { type: String, default: '' } },
  data() {
    return {
      loading: false,
      error: '',
      confirmPassword: '',
      form: {
        name: '',
        email: '',
        password: '',
        company_name: '',
        branch_name: 'Matriz',
        seller_token: '',
        invite_token: '',
      },
    };
  },
  mounted() {
    this.form.seller_token = (this.$route.query.vendedor || this.sellerToken || '').toString().toUpperCase();
    this.form.invite_token = (this.$route.query.invite || '').toString().toUpperCase();
  },
  methods: {
    ...mapActions(['register']),
    async handleRegister() {
      this.error = '';
      if (this.form.password !== this.confirmPassword) {
        this.error = 'Las contrasenas no coinciden.';
        return;
      }
      this.loading = true;
      try {
        const data = await this.register(this.form);
        this.$router.push(data.next_route || '/dashboard');
      } catch (error) {
        this.error = error.response?.data?.error || 'No se pudo completar el registro.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-page { min-height: 100vh; display: grid; place-items: center; padding: 2rem; }
.auth-shell { width: min(1120px, 100%); min-height: 720px; display: grid; grid-template-columns: .9fr 1.1fr; overflow: hidden; }
.auth-brand { padding: 3rem; display: flex; flex-direction: column; justify-content: flex-end; background: linear-gradient(135deg, var(--gt-accent), #f0b57e); color: #fff; }
.brand-badge { width: 4rem; height: 4rem; border-radius: 22px; display: grid; place-items: center; background: rgba(255,255,255,.22); font-weight: 900; margin-bottom: auto; }
.auth-brand h1 { font-size: clamp(2.1rem, 4.5vw, 3.6rem); line-height: .98; margin: 0 0 1rem; }
.auth-brand p { color: rgba(255,255,255,.85); }
.auth-form { padding: 3rem; display: flex; flex-direction: column; justify-content: center; }
h2 { margin: 1rem 0 .35rem; font-size: 2rem; }
form { display: grid; gap: 1rem; margin-top: 1.5rem; }
.two-cols { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }
.footer-link { color: var(--gt-muted); }
.footer-link a { color: var(--gt-primary); font-weight: 900; }
.error { background: #fff0ec; color: var(--gt-danger); padding: .85rem 1rem; border-radius: 16px; font-weight: 800; }
@media (max-width: 900px) { .auth-shell, .two-cols { grid-template-columns: 1fr; } .auth-brand { min-height: 280px; } }
</style>
